interface ArcheLoadingScreenProps {
  label?: string;
  className?: string;
}

export function ArcheLoadingScreen({
  label = 'Loading…',
  className = '',
}: ArcheLoadingScreenProps) {
  return (
    <div
      className={`flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-4 bg-background ${className}`}
      role="status"
      aria-live="polite"
    >
      <img src="/fias-logo.png" alt="Fias" className="h-12 w-auto animate-pulse dark:invert" />
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
  );
}
